<template>
	<div class="landscape">
		<div class="layer-landscape mountains-bg"></div>
		<div class="layer-landscape clouds-2"></div>
		<div class="layer-landscape clouds-4"></div>
	</div>
</template>
<script>
export default {
	name: "Sunset",
};
</script>
<style lang="scss" scoped>
.landscape {
	width: 100vw;
	height: 100vh;
	background: url("~@/assets/img/sunset/Background01.png");
	background-size: contain;
	image-rendering: pixelated;
	overflow: hidden;
	position: absolute;
	@media screen and (max-width: 768px) {
		background-size: cover;
	}
	.layer-landscape {
		position: absolute;
		height: 100%;
		width: 300%;
		filter: drop-shadow(0px 0px 15px rgba(0, 0, 0, 0.1));
		&.mountains-bg {
			background: url("~@/assets/img/sunset/BackgroundMuntain02.png");
			background-size: 33%;
			background-repeat: repeat-x;
			background-position: bottom;
			image-rendering: pixelated;
			animation: slide 18s linear infinite;
			z-index: 1;
		}
		&.clouds-1 {
			background: url("~@/assets/img/sunset/Cloud01.png");
			background-size: 33%;
			background-repeat: repeat-x;
			background-position: bottom;
			image-rendering: pixelated;
			animation: slide 16s linear infinite;
			z-index: 1;
		}
		&.clouds-2 {
			background: url("~@/assets/img/sunset/Cloud02.png");
			background-size: 33%;
			background-repeat: repeat-x;
			background-position: bottom;
			image-rendering: pixelated;
			animation: slide 16s linear infinite;
			z-index: 1;
		}
		&.clouds-3 {
			background: url("~@/assets/img/sunset/Cloud03.png");
			background-size: 33%;
			background-repeat: repeat-x;
			background-position: bottom;
			image-rendering: pixelated;
			animation: slide 12s linear infinite;
			z-index: 1;
		}
		&.clouds-4 {
			background: url("~@/assets/img/sunset/Clouds04.png");
			background-size: 33%;
			background-repeat: repeat-x;
			background-position: bottom;
			image-rendering: pixelated;
			animation: slide 14s linear infinite;
			z-index: 1;
		}
		&.paused {
			animation-play-state: paused;
		}
	}
}
@keyframes slide {
	0% {
		transform: translate(0);
	}
	100% {
		transform: translate(-33%);
	}
}
</style>
